module.exports = __webpack_public_path__ + "img/physics-avoidance-cover.1191172c.jpg";